<!-- CC: extracted from integrations.component.html -> Powershell popup section -->
<div class="flex-column f-1-0 overflow-auto gap-3" *ngIf="planInfo">

	<!--Connect section-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;" [ngClass]="isConnected() ? 'text-success' : 'text-warning'">{{isConnected() ? 'Connected' : 'Disconnected'}}</span>
			<span style="font-size: 12px; max-width: 300px;">{{isConnected() ? 'You are now logged in to Exchange Server PowerShell' :
				planInfo?.powershell?.enabled ? 'Your PowerShell integration has been disconnected due to an expired or invalid access token. Please reconnect to re-enable PowerShell functionality' :
				'Log in with your Exchange global admin credentials to create a PowerShell integration with ' + gs.corpname}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   endIcon="far fa-plug"
				   [loading]="integrationActionInProcess"
				   (action)="connectToPowershell();">
				{{isConnected() ? 'Disconnect' : planInfo?.powershell?.enabled ? 'Reconnect' : 'Connect'}}
			</btn-c>
		</div>
	</div>

	<!--Verify connection-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Verify connection</span>
			<span style="font-size: 12px; max-width: 300px;">Verify your Powershell integration with {{gs.corpname}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   [isDisabled]="integrationActionInProcess || !isConnected()"
				   (action)="openExchangePowershellPopup(exchangePowershellCommands.verify);">
				Verify
			</btn-c>
		</div>
	</div>

	<!--Set Inbound Exchange Connector & Rules-->
	<div class="flex-row gap-4" *ngIf="pageOrigin === 'inbound' || pageOrigin === 'admin'">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Set Inbound Exchange Connector & Rules</span>
			<span style="font-size: 12px; max-width: 300px;">
				Set up connectors and rules in Exchange to integrate your mail flow with {{gs.corpname}}.
			</span>
		</div>
		<div class="w-50">
			<btn-c (action)="openExchangePowershellPopup(exchangePowershellCommands.rules, 'inbound')"
				   endIcon="fa fa-magic"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				Configure
			</btn-c>
		</div>
	</div>

	<!--Set Outbound Exchange Connector & Rules-->
	<div class="flex-row gap-4" *ngIf="pageOrigin === 'outbound' || pageOrigin === 'admin'">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Set Outbound Exchange Connector & Rules</span>
			<span style="font-size: 12px; max-width: 300px;">
				Set up connectors and rules in Exchange to integrate your mail flow with {{gs.corpname}}.
			</span>
		</div>
		<div class="w-50">
			<btn-c (action)="openExchangePowershellPopup(exchangePowershellCommands.rules, 'outbound')"
				   endIcon="fa fa-magic"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				Configure
			</btn-c>
		</div>
	</div>

	<!--Disable Exchange Protection-->
	<div class="flex-row gap-4" *ngIf="pageOrigin === 'inbound' || pageOrigin === 'admin'">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Disable Exchange Protection</span>
			<span style="font-size: 12px; max-width: 300px;">Disable the default security policies in Exchange.</span>
		</div>
		<div class="w-50">
			<btn-c (action)="openExchangePowershellPopup(exchangePowershellCommands.protection)"
				   endIcon="far fa-times-circle"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				Configure
			</btn-c>
		</div>
	</div>

	<!--View Exchange Server Configuration-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">View Exchange Server Configuration</span>
			<span style="font-size: 12px; max-width: 300px;">Retrieve information from your Exchange server that can be used to validate your configurations.</span>
		</div>
		<div class="w-50">
			<btn-c (action)="openExchangePowershellPopup(exchangePowershellCommands.configuration)"
				   endIcon="fas fa-search"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				View
			</btn-c>
		</div>
	</div>

	<!--Create Trustifi Junk Rule-->
	<div *ngIf="pageOrigin === 'inbound' || pageOrigin === 'admin'" class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Create Trustifi Junk Rule</span>
			<span style="font-size: 12px; max-width: 300px;">Adds a mail-flow rule to move Trustifi-flagged messages to junk.</span>
		</div>
		<div class="w-50">
			<btn-c (action)="openExchangePowershellPopup(exchangePowershellCommands.junkRule, 'inbound')"
				   endIcon="fa fa-magic"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				Configure
			</btn-c>
		</div>
	</div>

	<!--Sync Blocklists-->
	<div *ngIf="pageOrigin === 'inbound' || pageOrigin === 'admin'" class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Sync Blocklists</span>
			<span style="font-size: 12px; max-width: 300px;">Sync blocklists from Exchange and import them into Trustifi.</span>
		</div>
		<div class="w-50">
			<btn-c (action)="syncPowershellBlocklists()"
				   endIcon="far fa-sync"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   style="width: 135px;">
				Sync
			</btn-c>
		</div>
	</div>

	<!--Sync Quarantined Emails from Exchange-->
	<div class="flex-row gap-4" *ngIf="pageOrigin === 'inbound' || pageOrigin === 'admin'">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Sync Quarantined Emails from Exchange</span>
			<span style="font-size: 12px; max-width: 300px;">
				Allow syncing quarantined emails from your Exchange server into {{gs.corpname}}.<br/>
				You can view these emails in the Inbound Quarantine page by selecting the "Microsoft Exchange" source parameter.
			</span>
		</div>
		<div class="w-50 flex-column gap-4">
			<toggle-switch-c id="enableSyncQuarantine"
							 [(model)]="planInfo.powershell.sync_quarantine"
							 [hideText]="true"
							 [isDisabled]="!isConnected() || integrationActionInProcess"
							 (onChange)="openExchangePowershellPopup(exchangePowershellCommands.enableSyncQuarantine)">
			</toggle-switch-c>

			<btn-c [isDisabled]="!planInfo.powershell.sync_quarantine || !isConnected() || integrationActionInProcess"
				   (action)="openPowershellAutoReleasePopup();">
				Release quarantined emails
			</btn-c>
		</div>
	</div>

	<!-- CC: temporarily hidden - "Import Exchange Quarantine to Trustifi" section (*ngIf forced to false) -->
	<div class="flex-row gap-4" *ngIf="false && (pageOrigin === 'inbound' || pageOrigin === 'admin')">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Import Exchange Quarantine to Trustifi</span>
			<span style="font-size: 12px; max-width: 300px;">
				Automatically moves emails from the Exchange quarantine into the Trustifi quarantine for centralized management.
			</span>
			<span style="font-size: 11px; max-width: 300px; color: #ef6c00; font-weight: 500;" *ngIf="planInfo.powershell.automatic_release">
				For best results, allow "Sync Quarantined Emails" to run for a few hours before enabling this feature.
			</span>
		</div>
		<div class="w-50 flex-column gap-4">
			<toggle-switch-c id="enableAutomaticRelease"
							 [(model)]="planInfo.powershell.automatic_release"
							 [hideText]="true"
							 [isDisabled]="!isConnected() || !planInfo.powershell.sync_quarantine || integrationActionInProcess"
							 (onChange)="openExchangePowershellPopup(exchangePowershellCommands.enableAutomaticRelease)">
			</toggle-switch-c>

			<span *ngIf="planInfo.powershell.automatic_release_date">
				Last release check at: {{planInfo.powershell.automatic_release_date | date:'MM/dd/yyyy HH:mm'}}
			</span>
		</div>
	</div>

</div>

<!--exchange powershell login wizard popup-->
<exchange-login-wizard-c
	class=""
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.login]?.show"
	[planInfo]="planInfo"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.login, $event.success, $event.disconnected)">
</exchange-login-wizard-c>

<!--exchange rules wizard popup (inbound)-->
<exchange-rules-wizard-c
	class=""
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.rules]?.show && exchangePowershellPopup[exchangePowershellCommands.rules]?.source === 'inbound'"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.rules, $event.success, $event.disconnected)"
	[domains]="exchangePowershellPopup[exchangePowershellCommands.rules]?.domains"
	[outboundRelayArchitecture]="planInfo?.outbound_relay?.sending_architecture || false"
	[isInboundConfiguration]="true"
	[useRegion]="planInfo?.use_region">
</exchange-rules-wizard-c>

<!--exchange rules wizard popup (outbound)-->
<exchange-rules-wizard-c
	class=""
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.rules]?.show && exchangePowershellPopup[exchangePowershellCommands.rules]?.source === 'outbound'"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.rules, $event.success, $event.disconnected)"
	[domains]="exchangePowershellPopup[exchangePowershellCommands.rules]?.domains"
	[outboundRelayArchitecture]="planInfo?.outbound_relay?.sending_architecture || false"
	[isInboundConfiguration]="false"
	[useRegion]="planInfo?.use_region">
</exchange-rules-wizard-c>

<!--review exchange cfg wizard popup-->
<view-exchange-cfg-wizard-c
	class=""
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.configuration]?.show"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.configuration, $event.success, $event.disconnected)"
	[isInboundConfiguration]="true">
</view-exchange-cfg-wizard-c>

<!--junk rule-->
<exchange-junk-rule-wizard-c
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.junkRule]?.show"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.junkRule, $event.success, $event.disconnected)">
</exchange-junk-rule-wizard-c>

<!--disable exchange protection wizard popup-->
<exchange-protection-wizard-c
	*ngIf="exchangePowershellPopup[exchangePowershellCommands.protection]?.show"
	(closePopupFn)="closeExchangePowershellPopup(exchangePowershellCommands.protection, $event.success, $event.disconnected)">
</exchange-protection-wizard-c>
